/**
 * Central configuration for AI service behavior
 * This is the single source of truth for AI generation counts and trigger settings.
 * Both frontend and backend import from this shared package.
 */
export const aiServiceConfig = {
    /**
     * Number of ideas to generate when generateIdeaService is called
     * Default: 2
     */
    IDEAS_TO_GENERATE: 5,
    AI_OPERATIONS_ACTIVE: true,
    /**
     * Number of document chunks to retrieve via RAG when generating AI content.
     * Higher = more research context but more prompt tokens and potential dilution.
     */
    RAG_TOP_K_CHUNKS: 8,
    /**
     * ========================================
     * PROACTIVE REGENERATION TRIGGER SETTINGS
     * ========================================
     * These settings control when AI regeneration is triggered after content changes.
     * Used by: useProactiveGeneration, useRatingsRegeneration, useLazyTrigger
     */
    /**
     * Minimum number of words that must change to trigger regeneration.
     * Prevents regeneration on typo fixes, punctuation changes, etc.
     * Example: Changing "hello world" to "hello worlds" (1 word) won't trigger.
     *          Changing "hello world" to "goodbye cruel world" (3 words) will trigger.
     */
    MIN_WORD_CHANGE_THRESHOLD: 3,
    /**
     * Debounce delay in milliseconds before triggering regeneration.
     * Waits for user to stop typing before regenerating.
     */
    REGENERATION_DEBOUNCE_MS: 3000,
    /**
     * Minimum content length (characters) required to trigger regeneration.
     * Prevents triggering for nearly-empty nodes.
     */
    MIN_CONTENT_LENGTH: 10,
    /**
     * Minimum word count across ALL fields to trigger AI generation.
     * This counts words from combined content (label + description + all category-specific fields).
     * Prevents generating suggestions for nodes with insufficient context.
     */
    MIN_WORD_COUNT: 5,
};
